import React, { useState, useEffect } from 'react'
import { setOpen, setEmail, setCustomer, setFirstCall } from '../store/accountSlice'
import { useSelector, useDispatch } from 'react-redux'
import { validateEmail } from '../../utils/helpers'
import { customerGetByAdmin } from '../../utils/Customer.js'
import CreateAccount from './CreateAccount.jsx'
import Login from './Login.jsx'
import Activate from './Activate.jsx'

const Popup = () => {
  const dispatch = useDispatch()
  const { open, email, customer, firstCall } = useSelector((state) => state.account)
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (open) {
      setActive(true);
    } else {
      const timer = setTimeout(() => {
        setActive(false);
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [open]);

  useEffect(() => {
    if (document.getElementById('login-customer-email')) document.getElementById('login-customer-email').value = email
  }, [email])

  const onEmailInput = (e) => {
    const emailValue = e.target?.value?.trim()
    dispatch(setEmail(emailValue))
    if(validateEmail(emailValue)) {
      customerGetByAdmin((res) => {
        dispatch(setCustomer(res.customer))
        dispatch(setFirstCall(true))
        window.queryCustomer = res.customer
      }, emailValue)
    } else {
      dispatch(setCustomer(null))
      window.queryCustomer = null
    }
  }

  return (
    <div className={`${open ? 'opened' : ''} ${active ? 'z-full opacity-100' : '-z-1 opacity-0'} popup fixed inset-0 transition smooth-transition bg-black bg-opacity-30 !flex items-center justify-center`}
      onClick={() => dispatch(setOpen(false))}
      style={{display: 'none'}}
    >
      <div className="popup-content border-l border-fourth-grey max-w-full max-h-full w-full lg:max-w-[33.125rem] bg-white absolute overflow-x-hidden overflow-y-auto bottom-0 top-0 right-0 flex flex-col justify-between"
        onClick={(e) => {
          e.stopPropagation()
        }}
      >

        <button className="z-20 absolute top-4 right-4 text-black" 
          aria-label="Close account form"
          onClick={() => dispatch(setOpen(false))}
        >
          <span dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-close'] }} />
        </button>
        <div className='px-6.25 pt-16 pb-12.5'>
          <div className='mb-9 text-sm'>{window.accountStrings.popup.account}</div>
          <div className={`text-xs ${firstCall && customer && customer?.state == 'ENABLED' && customer?.firstName ? 'mb-8' : ( customer && customer.email ? (customer ? 'mb-8' : '') : 'mb-8')}`}>
            { firstCall && customer && customer?.state == 'ENABLED' && customer?.firstName ? 
              `${window.accountStrings.popup.welcome}, ` + customer?.firstName : 
              ( customer && customer.email ? window.accountStrings.popup.activateAccount : window.accountStrings.popup.welcomeToTb) 
            }
            {
              firstCall && customer && customer?.state == 'ENABLED' && customer?.firstName && <span className="">{(Shopify.country == 'JP' ? '様' : (Shopify.country == 'KR' ? '님' : ''))}</span>
            }
          </div>
          
          <div className='mb-7 normal-case text-xs'>
            { email ? (firstCall ? (customer && customer?.state == 'ENABLED' ? window.accountStrings.popup.confirmPassword : (customer ? window.accountStrings.popup.reactivateText : window.accountStrings.popup.createAccount)) : window.accountStrings.popup.createAccount) : window.accountStrings.popup.enterEmail }
          </div>
          <div className='input-wrap group mb-10'>
            <input type='email' 
              className='input__field' 
              id='accountEmail'
              placeholder={window.accountStrings.popup.email}
              spellCheck="false" 
              autoCorrect='off'
              autoCapitalize="off" 
              autoComplete="email" 
              aria-required
              data-account-email
              name='accountEmail'
              onChange={e => onEmailInput(e)}
              onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
              onBlur={e => {
                e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target?.value)
              }}
            />
            <label htmlFor='accountEmail' className='input__label'>
              {window.accountStrings.popup.email}
            </label>
          </div>

          { firstCall && !!email && validateEmail(email) && !customer && <CreateAccount email={email} /> }
          { firstCall && customer && customer?.state == 'ENABLED' && <Login email={email} /> }
          { firstCall && !!email && validateEmail(email) && customer && customer?.state != 'ENABLED' && <Activate email={email} customer={customer} /> }
        </div>
        { window.accountStrings.popup.privacyTerms && <div className='text-xs normal-case mt-6 px-6.25 pb-6.25 lg:pb-12.5' dangerouslySetInnerHTML={{ __html: window.accountStrings.popup.registerText }} /> }
      </div>
    </div>
  )
}

export default Popup